import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import pluralize from 'pluralize';

import Button from '../../../../../../../../components/global/Button';
import { getThumbBySize } from '../../../../../../../../util/photo';
import { getAsset } from '../../../../../../../../util/assets';
import { truncateString } from '../../../../../../../../util/text';
import { IMAGE_SIZE_CODE } from '../../../../../../../../constants/image-size-codes';
import {
  getAccountCheckoutGreetingName,
  isProAccount,
} from '../../../../../../../../util/account';
import VerifiedIcon from '../../../../../../../../components/icons/VerifiedIcon';
import inIframe from '../../../../../../../../util/in-iframe';

const propTypes = {
  user: PropTypes.shape({
    avatar_photo: PropTypes.shape({
      id: PropTypes.string,
      thumbnail_urls: PropTypes.array,
    }),
    name: PropTypes.string,
    username: PropTypes.string,
  }),
};

const UserTile = ({ user }) => {
  const isPro = isProAccount(user);
  const userAvatar =
    getThumbBySize(user.avatar_photo?.thumbnail_urls, IMAGE_SIZE_CODE.SMALL2X)
      ?.url ?? getAsset('/user-menu-default.png');
  const userLogo = user.logo_image?.url ?? getAsset('/user-menu-default.png');
  const profilePic = isPro ? userLogo : userAvatar;
  const displayName = getAccountCheckoutGreetingName(user);
  const profileLink = user?.username ? `/@${user.username}` : undefined;
  const eventTotal = isPro
    ? (user.past_hierarchy_items?.total ?? 0) +
      (user.future_hierarchy_items?.total ?? 0)
    : user.hierarchy_items?.total ?? 0;

  const classes = classNames({
    'account-search-user-tile': true,
    'is-pro': isPro,
  });

  const profileLinkProps = inIframe()
    ? {
        target: profileLink ? '_blank' : undefined,
        rel: profileLink ? 'noopener noreferrer' : undefined,
      }
    : {};

  return (
    <Button
      btnStyle="reset"
      to={profileLink}
      className={classes}
      {...profileLinkProps}
    >
      <div
        className="user-tile-picture"
        style={{ backgroundImage: `url("${profilePic}")` }}
      />
      <div>
        <p className="account-result-name">
          {displayName} {isPro && <VerifiedIcon size={16} className="ml-1" />}
        </p>
        {user.username && (
          <p className="account-result-username">
            @{truncateString(user.username, 20)}{' '}
            {eventTotal > 0 && (
              <>&bull; {`${eventTotal} ${pluralize('event', eventTotal)}`}</>
            )}
          </p>
        )}
      </div>
    </Button>
  );
};

UserTile.propTypes = propTypes;

export default UserTile;
